import React, { useState } from "react";
import { useCart } from "react-use-cart";
import { generateLink } from "../../utils/ApiRequests";
import CustomerInfo from "./CustomerInfo";
import ShippingInfo from "./ShippingInfo";

const Checkout = () => {
  const [step, setStep] = useState(1);
  const [orderId, setOrderId] = useState("");
  const [loading, setloading] = useState(false);

  const gotoNext = () => {
    setStep(step + 1);
  };

  // const goBack = () => {
  //   setStep(step - 1);
  // };

  const { items } = useCart();

  const currentUrl = window.location.href;

  const generatePaymentLink = () => {
    const callback_url = `${currentUrl}/confirm-transaction`;

    generateLink(orderId, callback_url)
      .then((res) => {
        window.open(res.data.data.link, "paystack_window", "_self");
        setloading(false);
      })
      .catch((err) => {
        console.log(err.response);
        setloading(false);
      });
  };

  switch (step) {
    case 1:
      return (
        <CustomerInfo
          step={step}
          next={gotoNext}
          items={items}
          setOrderId={setOrderId}
          generatePaymentLink={generatePaymentLink}
          loading={loading}
          setLoading={setloading}
        />
      );

    case 2:
      return (
        <ShippingInfo
          step={step}
          items={items}
          submit={generatePaymentLink}
          loading={loading}
        />
      );

    default:
      return <CustomerInfo step={step} next={gotoNext} />;
  }
};

export default Checkout;
